"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PlusCircleIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(PlusCircleIcon, _React$PureComponent);

  function PlusCircleIcon() {
    _classCallCheck(this, PlusCircleIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlusCircleIcon).apply(this, arguments));
  }

  _createClass(PlusCircleIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'plus-circle-icon')
      }, props), _react.default.createElement("path", {
        fill: color,
        d: "M8.25,6.74910939 L6.75,6.74910939 L6.75,8.24907814 C6.75,8.66306952 6.414,8.99906252 6,8.99906252 C5.586,8.99906252 5.25,8.66306952 5.25,8.24907814 L5.25,6.74910939 L3.751,6.74910939 C3.337,6.74910939 3.001,6.41311639 3.001,5.99912502 C3.001,5.58513364 3.337,5.24914064 3.751,5.24914064 L5.25,5.24914064 L5.25,3.74917189 C5.25,3.33518052 5.586,2.99918752 6,2.99918752 C6.414,2.99918752 6.75,3.33518052 6.75,3.74917189 L6.75,5.24914064 L8.25,5.24914064 C8.664,5.24914064 9,5.58513364 9,5.99912502 C9,6.41311639 8.664,6.74910939 8.25,6.74910939 M10.242,1.75721339 C7.899,-0.585737797 4.101,-0.585737797 1.758,1.75721339 C-0.586,4.10116456 -0.586,7.89908544 1.758,10.2420366 C4.101,12.5859878 7.899,12.5859878 10.242,10.2420366 C12.586,7.89908544 12.586,4.10116456 10.242,1.75721339"
      }));
      /* eslint-enable max-len */
    }
  }]);

  return PlusCircleIcon;
}(_react.default.PureComponent);

exports.default = PlusCircleIcon;
PlusCircleIcon.defaultProps = {
  color: 'inherit'
};
PlusCircleIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};